import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import OnboardingChecklist from './OnboardingChecklist';
import useAuthStore from '../store/authStore';
import { isPublicAuthRoute, isPublicStaticRoute } from '../utils/routeUtils';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isPublicAuthRoute(location.pathname) || isPublicStaticRoute(location.pathname)) {
    return (
      <div className="min-h-screen bg-slate-50">
        {children}
      </div>
    );
  }

  // Routes that should not show the global header (they have their own navigation)
  const routesWithoutHeader = ['/admin', '/owner'];
  const shouldHideHeader = routesWithoutHeader.some(route =>
    location.pathname.startsWith(route)
  );

  // Onboarding page gets special treatment - no header, no checklist
  const isOnboardingPage = location.pathname === '/onboarding';

  // For non-authenticated pages, render without header
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-slate-50">
        {children}
      </div>
    );
  }

  // For onboarding page, render without header or checklist
  if (isOnboardingPage) {
    return (
      <div className="min-h-screen bg-slate-50">
        {children}
      </div>
    );
  }

  // For admin pages that have their own navigation, render without global header
  if (shouldHideHeader) {
    return (
      <div className="min-h-screen bg-slate-50">
        {children}
        <OnboardingChecklist />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* Fixed Header */}
      <Header />

      {/* Main Content Area - with padding for fixed header */}
      <main className="flex-1 pt-16">
        {children}
      </main>
      <OnboardingChecklist />
    </div>
  );
};

export default Layout;
